import { theme } from '@dfds-ui/theme';
export function getIntentColor() {
  var intent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';

  switch (intent) {
    case 'none':
      return theme.colors.surface.dark;

    case 'info':
      return theme.colors.primary.main;

    case 'critical':
      return theme.colors.status.alert;

    case 'success':
      return theme.colors.status.success;

    case 'warning':
      return theme.colors.status.warning;
  }
}
export function getIntentTextColor(intent) {
  switch (intent) {
    case 'none':
      return theme.colors.text.dark.primary;

    case 'info':
    case 'critical':
    case 'success':
    case 'warning':
      return theme.colors.text.light.primary;
  }
}